module.exports = __webpack_public_path__ + "img/ic_info_circle_green.ff03ccf3.svg";